// colors
export const BUTTON_BACKGROUND_COLOR = '#0082C8';
export const BUTTON_TEXT_COLOR = '#FFFFFF';
export const BUTTON_HEIGHT = '36px';

export const DELETE_COLOR = '#9F4268';